module.exports = __webpack_public_path__ + "static/img/Travis.Colyer.3e23ec5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Travis.Colyer.jpg
// module id = Cvym
// module chunks = 0